export default "__VITE_ASSET__BqkkWrX___"